import { KeycloakInitOptions } from 'keycloak-js';

/**
 * Keycloak initialization configuration for Capacitor/Cordova applications
 *
 * Uses 'login-required' to enforce authentication on app startup, ensuring users
 * are always authenticated before accessing app features. The cordova adapter
 * handles platform-specific OAuth flows.
 */
export const KEYCLOAK_PROVIDER_INIT_OPTIONS: KeycloakInitOptions = {
  onLoad: 'login-required', // Auto-redirect to login if not authenticated
  checkLoginIframe: false, // Disable iframe-based session checking (not needed in mobile)
  adapter: 'cordova', // Use Cordova adapter for mobile apps
  redirectUri: 'capacitor://localhost' // Custom scheme for OAuth callback handling
};
